module.exports = __webpack_public_path__ + "img/totalmeetings100.ea2756a3.png";